export enum Confirmation {
    Yes = 'yes',
    No = 'no'
}